import { BfrsProvider } from "@/components/ui/providers/BfrsProvider";
import { ComponentShowcasePage } from "./demo/ComponentShowcasePage";
import { IsolationTestPage } from "./demo/IsolationTestPage";

export default function App() {
  if (window.location.pathname === "/isolation-test") {
    return <IsolationTestPage />;
  }

  return (
    <BfrsProvider>
      <ComponentShowcasePage />
    </BfrsProvider>
  );
}
